<template>
  <Drawer
    :title="operateType === 'add' ? '新增模型' : '编辑模型'"
    :visible="visible"
    :before-close="close"
  >
    <template v-slot:default>
      <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
        <el-form-item label="供应商" prop="name">
          <el-input disabled v-model="provider" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="模型名" prop="name">
          <el-input
            :disabled="operateType === 'edit'"
            v-model="form.model_name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="模型类型" prop="name">
          <el-select
            v-model="form.model_type"
            :disabled="operateType === 'edit'"
            clearable
            placeholder="请选择模型类型"
          >
            <el-option
              v-for="item in modelTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabled" v-if="operateType === 'edit'">
          <el-select v-model="form.enabled" clearable placeholder="是否启用">
            <el-option
              v-for="item in modelUseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:footer>
      <el-button class="drawer-footer-btn" type="primary" @click="createModel">确定</el-button>
      <el-button class="drawer-footer-btn" @click="close">取消</el-button>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/drawer';
import _ from 'lodash';

export default {
  name: 'SandBoxTemplateCreate',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    provider: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        provider_name: '',
        model_name: '',
        model_type: '',
      },
      modelTypeOptions: [
        {
          label: 'llm',
          value: 'llm',
        },
        {
          label: 'text-embedding',
          value: 'text-embedding',
        },
        {
          label: 'rerank',
          value: 'rerank',
        },
        {
          label: 'speech2text',
          value: 'speech2text',
        },
        {
          label: 'tts',
          value: 'tts',
        },
      ],
      modelUseOptions: [
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        },
      ],
      rules: {
        provider_name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
      },
      checked: false,
      showJson: false,
    };
  },
  watch: {
    visible() {
      // this.row
      console.log('%c Line:102 🌽 this.row', 'color:#e41a6a', this.row);
      if (this.visible) {
        if (this.operateType === 'add') {
          this.form = {
            provider_name: '',
            credentials: '{}',
          };
        } else {
          this.form = _.cloneDeep(this.row);
        }
        this.$refs.form.resetFields();
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
    openJsonEdit() {
      this.showJson = true;
    },
    saveJson(json) {
      this.form.credentials = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    createModel() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // this.form
          console.log('%c Line:122 🥝 this.form', 'color:#ed9ec7', this.form);
          if (this.operateType === 'add') {
            const params = {
              provider_name: this.provider,
              model_name: this.form.model_name,
              model_type: this.form.model_type,
            };
            this.$request({
              url: this.$api.aiAddModel,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          } else {
            const params = {
              provider_name: this.provider,
              model_name: this.form.model_name,
              enabled: this.form.enabled,
            };
            // params
            console.log('%c Line:209 🍖 params', 'color:#ed9ec7', params);
            this.$request({
              url: this.$api.aiUpdateModel,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          }
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}

.el-checkbox {
  margin-left: 16px;
  width: 90%;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
  margin: 16px 0px;
  line-height: 32px;
}
</style>
